module.exports = __webpack_public_path__ + "img/monterey-g-series-top-angle.7724fc2a.png";